export default __webpack_public_path__ + "static/media/PeerToPeer.7cdec7c6.png";